






























import {Vue, Component} from 'vue-property-decorator';
import Navbar from "@/components/Navbar.vue";
import SideBar from "@/components/Sidebar.vue";
import {State} from "vuex-class";
import Footer from "./Footer.vue";

@Component({components: {navbar: Navbar, sidebar: SideBar, Footer}})
export default class Shell extends Vue {
  @State pageSubtitle;

  mounted() {
    $('#sidebar').aceSidebar();
  }

  notificationSelected(notification) {
  }

  get routeName() {
    return this.$route.name !== 'poseta';
  }

}
